// extracted by mini-css-extract-plugin
export default {"checkboxBaseStyle":"Checkbox_checkboxBaseStyle__mZHXm"};